﻿document.addEventListener('DOMContentLoaded', () => {
    const $menuElement = document.getElementById('mainmenu');
    const $navbarBurger = document.getElementById('navbar-burger');

    if (typeof $navbarBurger !== 'undefined' && typeof $menuElement !== 'undefined') {
        const $drillLinks = [...$menuElement.querySelectorAll('.mainmenu-drilldownlink')];
        const $backLinks = [...$menuElement.querySelectorAll('.mainmenu-backlink')];

        $navbarBurger.addEventListener('click', (event) => {
            $navbarBurger.classList.toggle('is-active');
            $menuElement.classList.toggle('is-active');
        });

        document.addEventListener('click', (event) => {
            let isClickInside = false;

            if ($menuElement.contains(event.target) || $navbarBurger.contains(event.target)) {
                isClickInside = true;
            }

            if (!isClickInside) {
                $navbarBurger.classList.remove('is-active');
                $menuElement.classList.remove('is-active');
            }
        });

        $drillLinks.forEach(drillLink => {
            drillLink.addEventListener('click', (event) => {
                let $targetMenu = drillLink.nextSibling.nextSibling;
                $targetMenu.classList.add('active');
            }, false);
        });

        $backLinks.forEach(backLink => {
            backLink.addEventListener('click', (event) => {
                let $targetMenu = event.target.closest('.mainmenu-child');
                $targetMenu.classList.remove('active');
            }, false);
        });
    }
});
